<template lang="pug">
  shListData(title="Products History" resolver="productsHistory" keyData="_id" component="shProduct" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'ProductsHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/product/ProductsHistory.vue